import { NetworkEffect } from './components/NetworkEffect';
import { Links } from './components/Links';
import { MainText } from './components/MainText';
import { GrowthDrivers } from './components/GrowthDrivers';
import { AboutVerticals } from './components/AboutVerticals';

export const Main: React.FC = () => {
  return (
    <div>
      <MainText />
      <NetworkEffect />
      <GrowthDrivers />
      <AboutVerticals />
      <Links />
    </div>
  );
};
